/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { memoize } from 'lodash';

// Components
import BaseCalendar from 'shared/ui/components/calendars/BaseCalendar.vue';

const __vue_script__ = {
    name: 'SchedulerView',

    components: {
        BaseCalendar
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        events: {
            type: Array,
            required: true
        },

        resources: {
            type: Array,
            required: true
        },

        allDay: {
            type: Boolean,
            default: false
        },

        showDays: {
            type: Boolean,
            default: false
        },

        dragToMove: {
            type: Boolean,
            default: false
        },

        dragToResize: {
            type: Boolean,
            default: false
        },

        invalid: {
            type: Array,
            default: () => []
        },

        eventComponent: {
            type: Object,
            default: () => null
        },

        resourceComponent: {
            type: Object,
            default: () => null
        },

        calendarConfig: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            config: { ...this.calendarConfig },
            eventComponentClass: null,
            resComponentClass: null
        };
    },

    watch: {
        events() {
            if (this.eventComponentClass) {
                for (const child of this.$children) {
                    if (child instanceof this.eventComponentClass) {
                        child.$destroy();
                    }
                }
            }
        },

        resources() {
            if (this.resComponentClass) {
                for (const child of this.$children) {
                    if (child instanceof this.resComponentClass) {
                        child.$destroy();
                    }
                }
            }
        }
    },

    created() {
        if (this.eventComponent) {
            this.eventComponentClass = this.$root.$options.extend(this.eventComponent);
        }

        if (this.resourceComponent) {
            this.resComponentClass = this.$root.$options.extend(this.resourceComponent);
        }
    },

    mounted() {
        this.initScheduler();
    },

    methods: {
        initScheduler() {
            const config = {
                view: {
                    schedule: {
                        allDay: this.allDay,
                        days: this.showDays,
                        maxEventStack: 3,
                        minEventWidth: 85,
                        type: 'day',
                        timeCellStep: 10,
                        timeLabelStep: 60,
                        currentTimeIndicator: true
                    }
                },
                ...this.config
            };

            const render = memoize((Ctor, info) => this.renderComponent(Ctor, info), (_, info) => {
                let status = '';
                if (info.original?.origin) {
                    status = this.$utils.calendar.computeEventStatus(info.original.origin, info.currentResource);
                }
                const id = info.id;
                const rid = info.currentResource?.id || '';
                const objectHash = info.original ? this.$utils.objects.hashObject(info.original) : '';
                return `${id}-${rid}-${status}-${objectHash}`;
            });

            if (this.eventComponentClass) {
                config.renderEvent = (event) => render(this.eventComponentClass, event);
                config.renderScheduleEvent = (event) => render(this.eventComponentClass, event);
            }

            if (this.resComponentClass) {
                config.renderResource = (resource) => render(this.resComponentClass, resource);
            }

            this.config = config;
        },

        renderComponent(ComponentClass, info) {
            const vm = new ComponentClass({ propsData: { event: this.event, info } }).$mount();
            return vm.$el.outerHTML;
        },

        /**
         * Removes an event from the calendar.
         *
         * @param {Object} event - The event to be removed.
         */
        removeEvent(event) {
            this.$refs.calendar.runtime.removeEvent(event);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scheduler-view" },
    [
      _c(
        "base-calendar",
        _vm._g(
          {
            ref: "calendar",
            attrs: {
              events: _vm.events,
              resources: _vm.resources,
              "drag-to-move": _vm.dragToMove,
              "drag-to-resize": _vm.dragToResize,
              "display-timezone": _vm.event.timezone,
              invalid: _vm.invalid,
              "calendar-config": _vm.config,
            },
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/calendars/SchedulerView.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__